import React, { useState, useEffect } from "react"
import {
    CountdownWrapper,
    CountdownHeading,
    CountdownNumbersWrapper,
    CountdownNumber,
    Separator,
} from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CountdownTimer/CountdownTimer.styles"
import { ColonSeparatorIcon } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CountdownTimer/ColonSeparatorIcon"
import {
    calculateTimeRemaining,
    TimeUnits,
} from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CountdownTimer/CountdownTimer.helper"

interface CountdownTimerProps {
    targetDate: Date
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({ targetDate }) => {
    const [timeRemaining, setTimeRemaining] = useState<TimeUnits>(calculateTimeRemaining(targetDate))

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeRemaining(calculateTimeRemaining(targetDate))
        }, 1000)

        return () => clearInterval(timer)
    }, [targetDate])

    return (
        <CountdownWrapper>
            <CountdownHeading>
                <span>🗓️</span>
                <span>Election Day starts in...</span>
            </CountdownHeading>
            <CountdownNumbersWrapper>
                <CountdownNumber>
                    <div className="number">{String(timeRemaining.days).padStart(2, "0")}</div>
                    <div className="label">days</div>
                </CountdownNumber>
                <Separator aria-hidden="true">
                    <ColonSeparatorIcon width="100%" height="100%" />
                </Separator>
                <CountdownNumber>
                    <div className="number">{String(timeRemaining.hours).padStart(2, "0")}</div>
                    <div className="label">hours</div>
                </CountdownNumber>
                <Separator aria-hidden="true">
                    <ColonSeparatorIcon width="100%" height="100%" />
                </Separator>
                <CountdownNumber>
                    <div className="number">{String(timeRemaining.minutes).padStart(2, "0")}</div>
                    <div className="label">minutes</div>
                </CountdownNumber>
                <Separator aria-hidden="true">
                    <ColonSeparatorIcon width="100%" height="100%" />
                </Separator>
                <CountdownNumber>
                    <div className="number">{String(timeRemaining.seconds).padStart(2, "0")}</div>
                    <div className="label">seconds</div>
                </CountdownNumber>
            </CountdownNumbersWrapper>
        </CountdownWrapper>
    )
}
